import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export type IboOnboardingSortDirection = "asc" | "desc";

/**
 * Redux state interface for IBO Onboarding Action Report.
 *
 * @interface IboOnboardingARState
 * @property {IboOnboardingSortDirection} sortDirection - Current sort direction for the IBO Onboarding report list
 * @property {string[]} affAbosToExpand - List of AFF-ABO identifiers to expand in tree view
 */
interface IboOnboardingARState {
  sortDirection: IboOnboardingSortDirection;
  affAbosToExpand: string[];
}

export const initialState: IboOnboardingARState = {
  sortDirection: "desc",
  affAbosToExpand: [],
};

const { actions, reducer } = createSlice({
  name: "iboOnboardingActionReport",
  initialState,
  reducers: {
    toggleSortDirection: (state) => {
      state.sortDirection = state.sortDirection === "asc" ? "desc" : "asc";
    },
    setAffAbosToExpand: (state, action: PayloadAction<string[]>) => {
      state.affAbosToExpand = action.payload;
    },
  },
});

export const { toggleSortDirection, setAffAbosToExpand } = actions;

export default reducer;
